import { render, staticRenderFns } from "./PlatformNotificationComponent.vue?vue&type=template&id=330af48d&scoped=true"
import script from "./PlatformNotificationComponent.vue?vue&type=script&lang=js"
export * from "./PlatformNotificationComponent.vue?vue&type=script&lang=js"
import style0 from "./PlatformNotificationComponent.vue?vue&type=style&index=0&id=330af48d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330af48d",
  null
  
)

export default component.exports